// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Xe7F","footer":"ChangeClinic_footer__2Fkq9"};